import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteSiteTitle, getSiteTitles } from '../../../../../api/endpoints/cmsSite';
import type { SiteTitle } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { SiteTitleFormDialog } from '../SiteTitleFormDialog';

export default function SiteTitleListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<SiteTitle | null>(null);

  const query = useQuery({ queryKey: ['cms', 'siteTitles', siteId], queryFn: () => getSiteTitles(siteId) });
  const rows: SiteTitle[] = useMemo(() => query.data?.siteTitles ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteSiteTitle(id),
    invalidateKeys: [['cms', 'siteTitles']],
    successMessage: 'Site başlığı silindi.',
  });

  const columns: DataTableColumn<SiteTitle>[] = [
    { id: 'position', header: 'Sıra', cell: (r) => r.position ?? '—' },
    { id: 'title', header: 'Başlık', cell: (r) => r.title ?? '—' },
    { id: 'subtitle', header: 'Alt Başlık', cell: (r) => r.subTitle ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="Site Başlıkları"
      headerVariant="section"
      createLabel="Yeni Site Başlığı"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı site başlığı bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <SiteTitleFormDialog open={createOpen} siteTitle={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <SiteTitleFormDialog open={!!editing} siteTitle={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="Site başlığını sil"
        description="Bu site başlığını silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
